// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {"4565": "b91b5e9cad306228","5287": "b760c28bd5e81ef1",}[chunkId] + ".css"
}